import LxcError from "~/core/models/LxcError.class";
import operationManagerService from "~/core/services/operationManager.service";
import type { DtwinCreateOperation } from "~/modules/dtwin/models/DtwinCreateOperation.interface";
import type { DtwinOperation } from "~/modules/dtwin/models/DtwinOperation.interface";
import type { DtwinOperationCertificateInputParameters } from "~/modules/dtwin/models/DtwinOperationCertificateInputParameters.interface";

export function useCreateOperationRenewCertificate({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const isLoading = ref(false);
  const error = ref();
  const result: Ref<
    DtwinOperation<DtwinOperationCertificateInputParameters> | undefined
  > = ref();

  async function create(
    operation: DtwinCreateOperation<DtwinOperationCertificateInputParameters>,
  ) {
    if (!organizationCode) {
      throw new Error("Organization code is undefined");
    }

    isLoading.value = true;
    error.value = undefined;

    const response = await operationManagerService.createOperation(
      organizationCode,
      operation,
    );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value =
        response as unknown as DtwinOperation<DtwinOperationCertificateInputParameters>;
    }

    isLoading.value = false;
  }

  return {
    create,
    isLoading,
    error,
    result,
  };
}
